"use strict";
/*  Profile View
*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileView = void 0;
var lit_html_1 = require("lit-html");
var style_map_js_1 = require("lit-html/directives/style-map.js");
var baseStyles_1 = require("./baseStyles");
var ChatWithMe_1 = require("./ChatWithMe");
var FriendList_1 = require("./FriendList");
var presenter_1 = require("./presenter");
var CVPresenter_1 = require("./CVPresenter"); // 20210527
var StuffPresenter_1 = require("./StuffPresenter"); // 20210527
var ProfileCard_1 = require("./ProfileCard");
var CVCard_1 = require("./CVCard");
var StuffCard_1 = require("./StuffCard");
var QRCodeCard_1 = require("./QRCodeCard");
var addMeToYourFriends_1 = require("./addMeToYourFriends");
function ProfileView(subject, context) {
    return __awaiter(this, void 0, void 0, function () {
        var profileBasics, rolesByType, stuffData, styles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    profileBasics = (0, presenter_1.presentProfile)(subject, context.session.store);
                    rolesByType = (0, CVPresenter_1.presentCV)(subject, context.session.store);
                    return [4 /*yield*/, (0, StuffPresenter_1.presentStuff)(subject)];
                case 1:
                    stuffData = _a.sent();
                    styles = {
                        grid: (0, style_map_js_1.styleMap)(__assign(__assign(__assign({}, (0, baseStyles_1.responsiveGrid)()), (0, baseStyles_1.paddingSmall)()), { background: "radial-gradient(circle, ".concat(profileBasics.backgroundColor, " 80%, ").concat(profileBasics.highlightColor, " 100%)") })),
                        card: (0, style_map_js_1.styleMap)((0, baseStyles_1.card)()),
                        chat: (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_1.card)()), (0, baseStyles_1.padding)())),
                    };
                    return [2 /*return*/, (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    <div style=\"", "\">\n      <div>\n        <div data-testid=\"profile-card\" style=\"", "\">\n          ", "\n          ", "\n        </div>\n      </div>\n        ", "\n        ", "\n        ", "\n      <div style=\"", "\">", "</div>\n      <div data-testid=\"qrcode-display\" style=\"", "\">\n        ", "\n      </div>\n    </div>\n  "], ["\n    <div style=\"", "\">\n      <div>\n        <div data-testid=\"profile-card\" style=\"", "\">\n          ", "\n          ", "\n        </div>\n      </div>\n        ", "\n        ", "\n        ", "\n      <div style=\"", "\">", "</div>\n      <div data-testid=\"qrcode-display\" style=\"", "\">\n        ", "\n      </div>\n    </div>\n  "])), styles.grid, styles.card, (0, ProfileCard_1.ProfileCard)(profileBasics), (0, addMeToYourFriends_1.addMeToYourFriendsDiv)(subject, context), (0, CVCard_1.CVCard)(profileBasics, rolesByType), (0, StuffCard_1.StuffCard)(profileBasics, context, subject, stuffData), (0, FriendList_1.FriendList)(profileBasics, subject, context), styles.chat, (0, ChatWithMe_1.ChatWithMe)(subject, context), styles.card, (0, QRCodeCard_1.QRCodeCard)(profileBasics, subject))];
            }
        });
    });
}
exports.ProfileView = ProfileView;
var templateObject_1;
//# sourceMappingURL=ProfileView.js.map